export enum DashboardSectionType {
    TEXT = 'text',
    RECIPE_CARD = 'recipe_card',
    RECIPE_CAROUSEL = 'recipe_carousel',
    COLLECTION_CARD = 'collection_card',
    COLLECTION_CAROUSEL = 'collection_carousel',
    USER_CARD = 'user_card',
    USER_CAROUSEL = 'user_carousel',
}
